import { combineEpics } from 'redux-observable';
import { loadCities } from './loadCities';

export default combineEpics(loadCities);



// WEBPACK FOOTER //
// ./src/scenes/Cities/services/epics/index.ts